import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Navimumbaiairporttogoacab() {



  const cardData = {
    keyword: " Navi Mumbai Airport to Goa Cabs ",


"headingDescription": "Royal Route Cab offers reliable Navi Mumbai Airport to Goa cab service, providing safe, comfortable, and long-distance travel solutions for families, couples, tourists, and group travelers. The distance between Navi Mumbai Airport and Goa is approximately 580–620 km, and the journey typically takes 10–12 hours via NH48 or the scenic coastal NH66 route. Our professional drivers ensure a smooth and stress-free ride with timely airport pickup, luggage assistance, and well-maintained vehicles. We offer flexible options including one-way drops, round trips, multi-day travel, and customized Goa tour packages. Our fleet includes air-conditioned sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for all group sizes. With 24/7 availability, transparent pricing, and easy booking, Royal Route Cab is your trusted choice for Navi Mumbai Airport to Goa cab service.",

"topPlaces": [
  {
    "title": "North Goa Beaches",
    "description": "North Goa is famous for its lively and energetic beaches such as Baga, Calangute, Candolim, and Anjuna. These beaches are known for water sports, beach parties, nightlife, and vibrant shacks offering delicious seafood and drinks. Travelers coming from Navi Mumbai Airport often prefer North Goa for its entertainment options, clubs, and social atmosphere. The area is perfect for young travelers, groups, and anyone looking to enjoy Goa’s famous nightlife along with beachside relaxation."
  },
  {
    "title": "South Goa Beaches",
    "description": "South Goa is known for its peaceful and less crowded beaches like Colva, Benaulim, Palolem, and Agonda. These beaches offer a calm and relaxing environment, making them ideal for couples, families, and travelers seeking a quiet getaway. The clean coastline, scenic beauty, and serene atmosphere provide a perfect escape from city life after a long cab journey from Navi Mumbai Airport."
  },
  {
    "title": "Panaji (Panjim City)",
    "description": "Panaji is the capital city of Goa known for its Portuguese-style architecture, colorful streets, casinos, and riverside views along the Mandovi River. Visitors can explore local markets, churches, and cafes while enjoying a blend of Indian and Portuguese culture. It is a central hub for tourists traveling across Goa."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Dudhsagar Waterfalls is one of the tallest waterfalls in India and a major attraction for nature lovers. Located on the Goa-Karnataka border, it is surrounded by lush forests and is especially spectacular during monsoon season when the water flow is at its peak. It is a must-visit destination for adventure seekers and photographers."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "The Basilica of Bom Jesus is a UNESCO World Heritage Site and one of the most famous churches in India. It houses the relics of St. Francis Xavier and showcases beautiful baroque architecture. It is a major spiritual and historical attraction visited by tourists from around the world."
  },
  {
    "title": "Fort Aguada",
    "description": "Fort Aguada is a well-preserved Portuguese fort offering panoramic views of the Arabian Sea. It is a popular tourist spot for history lovers and photographers, especially during sunset when the views are stunning. The lighthouse within the fort adds to its charm."
  },
  {
    "title": "Chapora Fort",
    "description": "Chapora Fort is famous for its scenic views and Bollywood popularity. Located near Vagator Beach, it offers breathtaking views of the coastline and is a great spot for photography and sunset viewing. It attracts a large number of tourists every year."
  },
  {
    "title": "Goa Casinos",
    "description": "Goa is known for its offshore and onshore casinos located mainly in Panaji. These casinos offer gaming, entertainment shows, dining, and nightlife experiences. They are a major attraction for tourists looking for luxury and entertainment during their Goa trip."
  },
  {
    "title": "Anjuna Flea Market",
    "description": "Anjuna Flea Market is a vibrant shopping destination where visitors can buy clothes, accessories, handicrafts, souvenirs, and more. It reflects Goa’s hippie culture and is a must-visit for shoppers and tourists looking for unique items."
  },
  {
    "title": "Spice Plantations",
    "description": "Goa’s spice plantations offer guided tours where visitors can learn about traditional spice farming, enjoy local Goan meals, and experience nature. These plantations provide a refreshing and educational experience away from the beaches."
  }
],






services: [
  {
    name: "Mumbai to Goa Cab",
    description: "Mumbai to Goa cab service offers a comfortable and scenic coastal journey ideal for vacations, family trips, and group travel. Enjoy smooth highway routes with experienced drivers and well-maintained vehicles. Perfect for those who prefer road trips over flights. It guarantees a relaxing and memorable travel experience."
  },
  {
    name: "Mumbai to Goa Taxi Fare",
    description: "Mumbai to Goa taxi fare is transparent and depends on vehicle type, trip duration, and route. Customers receive clear pricing details before booking. No hidden charges ensure trust. It helps in planning travel costs efficiently."
  },
  {
    name: "Mumbai to Goa Taxi",
    description: "Mumbai to Goa taxi provides private and flexible travel for long-distance journeys. Ideal for individuals, couples, and families. Comfortable vehicles ensure a smooth ride. It guarantees a reliable and enjoyable journey."
  },
  {
    name: "Mumbai to Goa Cab Fare",
    description: "Mumbai to Goa cab fare varies based on car type and travel plan. Budget and premium options are available to suit different needs. Transparent pricing ensures convenience. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Goa Taxi One Way Fare",
    description: "Mumbai to Goa taxi one way fare offers economical travel without return charges. Ideal for single-side trips. Flexible pickup options enhance convenience. It ensures smooth and budget-friendly travel."
  },
  {
    name: "Mumbai to Goa Cab Price",
    description: "Mumbai to Goa cab price depends on distance, vehicle selection, and trip duration. Customers can choose from sedan, SUV, and premium cars. Clear pricing ensures no surprises. It helps in easy planning."
  },
  {
    name: "Mumbai to Goa by Car Fare",
    description: "Mumbai to Goa by car fare provides a complete estimate for road travel costs including vehicle and driver charges. Ideal for tourists planning road trips. Transparent pricing enhances trust. It ensures clarity in expenses."
  },
  {
    name: "Mumbai Airport to Goa Cab",
    description: "Mumbai airport to Goa cab offers direct transfers from airport terminals to Goa. Ideal for travelers arriving by flight. Professional drivers ensure timely pickup. It guarantees a stress-free journey."
  },
  {
    name: "Mumbai Goa Cab Service",
    description: "Mumbai Goa cab service provides reliable intercity transportation with comfortable vehicles and experienced drivers. Suitable for family vacations and long trips. It ensures a safe and pleasant journey."
  },
  {
    name: "Mumbai to Goa Cab Booking",
    description: "Mumbai to Goa cab booking allows customers to reserve rides easily with flexible options. Travelers can select vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mumbai to Goa Cab Charges",
    description: "Mumbai to Goa cab charges are calculated based on vehicle type, route, and duration. Transparent pricing ensures no hidden costs. Customers can choose affordable or premium options. It helps in budget planning."
  },
  {
    name: "Mumbai to Goa Cab Service",
    description: "Mumbai to Goa cab service ensures dependable long-distance travel with professional drivers. Ideal for leisure and business trips. Clean vehicles enhance comfort. It guarantees a smooth travel experience."
  },
  {
    name: "Mumbai to Goa Car Hire",
    description: "Mumbai to Goa car hire offers flexible vehicle options for personal and group travel. Customers can choose hourly or outstation packages. Comfortable interiors enhance travel experience. It ensures convenience."
  },
  {
    name: "Mumbai to Goa Taxi Price",
    description: "Mumbai to Goa taxi price varies based on vehicle selection and trip plan. Budget and luxury options are available. Clear pricing ensures transparency. It helps in easy travel planning."
  },
  {
    name: "Navi Mumbai Airport to Goa Cabs",
    description: "Navi Mumbai airport to Goa cabs provide direct transfers from airport terminals to Goa. Ideal for travelers seeking convenience after flights. Comfortable vehicles ensure a smooth ride. It guarantees a hassle-free journey."
  },
  {
    name: "Navi Mumbai Airport to Goa Cab",
    description: "Navi Mumbai airport to Goa cab offers reliable long-distance travel with door-to-door pickup. Professional drivers ensure safety and punctuality. It ensures a comfortable travel experience."
  },
  {
    name: "Navi Mumbai Airport to Goa Taxi",
    description: "Navi Mumbai airport to Goa taxi provides private and flexible travel options for long-distance journeys. Comfortable seating enhances the ride. Ideal for families and groups. It guarantees reliability."
  },
  {
    name: "Cab from Navi Mumbai Airport to Goa",
    description: "Cab from Navi Mumbai airport to Goa offers direct and convenient travel after flight arrival. This service ensures timely pickup and smooth highway travel. It ensures a relaxed journey."
  },
  {
    name: "Taxi from Navi Mumbai Airport to Goa",
    description: "Taxi from Navi Mumbai airport to Goa provides dependable intercity travel with experienced drivers. Comfortable vehicles ensure a pleasant journey. It guarantees a reliable experience."
  },
  {
    name: "Book Cab Navi Mumbai Airport to Goa",
    description: "Book cab Navi Mumbai airport to Goa with easy online booking and instant confirmation. Customers can select vehicle type, pickup time, and location. Transparent pricing ensures trust. It simplifies travel planning."
  },
  {
    name: "Online Cab Booking Navi Mumbai Airport to Goa",
    description: "Online cab booking Navi Mumbai airport to Goa provides a quick and convenient way to reserve your ride. Secure payment and instant confirmation enhance convenience. Multiple vehicle options are available. It ensures hassle-free booking."
  }
],

tableData: [
  ["Mumbai to Goa Cab", "Mumbai to Goa Taxi Fare"],
  ["Mumbai to Goa Taxi", "Mumbai to Goa Cab Fare"],
  ["Mumbai to Goa Taxi One Way Fare", "Mumbai to Goa Cab Price"],
  ["Mumbai to Goa by Car Fare", "Mumbai Airport to Goa Cab"],
  ["Mumbai Goa Cab Service", "Mumbai to Goa Cab Booking"],
  ["Mumbai to Goa Cab Charges", "Mumbai to Goa Cab Service"],
  ["Mumbai to Goa Car Hire", "Mumbai to Goa Taxi Price"],
  ["Navi Mumbai Airport to Goa Cabs", "Navi Mumbai Airport to Goa Cab"],
  ["Navi Mumbai Airport to Goa Taxi", "Cab from Navi Mumbai Airport to Goa"],
  ["Taxi from Navi Mumbai Airport to Goa", "Book Cab Navi Mumbai Airport to Goa"],
  ["Online Cab Booking Navi Mumbai Airport to Goa", ""]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Navi Mumbai Airport to Goa Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable cab service from Navi Mumbai Airport to Goa, perfect for long-distance trips, vacations, and family travel."
  },
  {
    WhyChooseheading: "Direct Airport Pickup with Flight Tracking",
    WhyChoosedescription: "We track flight timings to ensure timely pickup even in case of delays, providing a stress-free airport transfer."
  },
  {
    WhyChooseheading: "Experienced Highway & Ghat Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Mumbai–Goa highway and ghat routes, ensuring safe and smooth long-distance travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear fare details including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service or round-trip Goa packages based on your travel plan."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Navi Mumbai Airport to Goa cab service operates round the clock for flexible departure anytime."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Long-Distance Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for reliable airport to Goa cab bookings with punctual service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Navi Mumbai Airport to Goa cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Navi Mumbai Airport to Goa." },
  { question: "What is the distance between Navi Mumbai Airport and Goa?", answer: "The distance is approximately 525 km and takes around 10 to 12 hours depending on route and traffic." },
  { question: "What is the taxi fare for this route?", answer: "Taxi fare starts from ₹7500 to ₹9000 for sedan and may go higher depending on vehicle type." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Do you provide one-way cab service?", answer: "Yes, we provide one-way and round-trip cab services." },
  { question: "Do you track flight delays?", answer: "Yes, we track flights to ensure timely pickup." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for long-distance travel." },
  { question: "Do you provide doorstep drop in Goa?", answer: "Yes, we provide drop to hotel, resort, or any location in Goa." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sahil Deshmukh",
    feedback: "The Navi Mumbai Airport to Goa cab with Royal Route Cabs was an excellent long journey experience. The ride was comfortable, and the driver handled the highway travel very professionally.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Naik",
    feedback: "Great experience traveling from Navi Mumbai Airport to Goa. The cab was clean, spacious, and the entire trip felt safe and relaxing with Royal Route Cabs.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Airport to Goa Cab",
  "image": "https://www.royalroutecabs.com/assets/images/navi-mumbai-airport-to-goa-cab.jpg", // replace if needed
  "description": "Book Navi Mumbai Airport to Goa cab service with Royal Route Cabs for safe and comfortable long-distance travel. Enjoy 24x7 outstation taxi service with sedan, SUV, Innova, and luxury car options for one-way and round-trip journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7999", // approx starting fare (adjust as needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/navi-mumbai-airport-to-goa-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Navi Mumbai Airport to Goa Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Navi Mumbai Airport to Goa cab with Royal Route Cabs. Safe and reliable long-distance taxi service with affordable fares, experienced drivers, and 24x7 availability."
  />

  <meta
    name="keywords"
    content="mumbai to goa cab, mumbai to goa taxi fare, mumbai to goa taxi, mumbai to goa cab fare, mumbai to goa taxi one way fare, mumbai to goa cab price, mumbai to goa by car fare, mumbai airport to goa cab, mumbai goa cab service, mumbai to goa cab booking, mumbai to goa cab charges, mumbai to goa car hire, mumbai to goa taxi price, navi mumbai airport to goa cabs, navi mumbai airport to goa cab, navi mumbai airport to goa taxi, cab from navi mumbai airport to goa, taxi from navi mumbai airport to goa, book cab navi mumbai airport to goa, online cab booking navi mumbai airport to goa, best cab navi mumbai airport to goa, cheapest cab navi mumbai airport to goa, reliable taxi navi mumbai airport to goa, one way cab navi mumbai airport to goa"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/86.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiairporttogoacab;